<div class="mini-grid">
  <div class="mini-grid_title">{{title ? title : 'Fba History'}}</div>

  <div class="mini-grid_grid-wrapper">
    <ag-grid-angular
      style="width: 100%; height: 300px"
      class="ag-theme-alpine-thin"
      [gridOptions]="gridOptions"
      [headerHeight]="30"
      [rowHeight]="30"
    >
    </ag-grid-angular>
  </div>
</div>
